var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","max-width":"500"}},[_c('v-card-title',[_vm._v("詳細")]),_c('v-card-text',[_c('v-textarea',{attrs:{"value":_vm.value},on:{"input":(ev) => _vm.$emit('input', ev)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }